<script>
import Vuex from "vuex";

export default {
  name: "TradovateShowConnected",
  mixins: [],
  components: {},
  props: [],
  data() {
    return {
      debug: false,
    };
  },
  methods: {
    ...Vuex.mapActions(["show_error_message", "show_info_message"]),
  },
  mounted() {
    let query = this.T.copy(this.$route.query);
    let clean_url = false;
    if (query?.error) {
      this.show_error_message({ message: query.error });
      delete query.error;
      clean_url = true;
    }
    if (query?.connected && query?.node_broker_id) {
      this.show_info_message({
        message: `Broker connected (${query.node_broker_id})`,
      });
      delete query.connected;
      delete query.node_broker_id;
      clean_url = true;
    }
    if (clean_url) this.$router.replace({ query: query });
  },
};
</script>
